export default __webpack_public_path__ + "static/media/nextone.6a4423b7.png";